<template>
  <div>
    <!--Page start-->
    <section class="auth-page">
      <div class="animation-circle-inverse">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="animation-circle">
        <i></i>
        <i></i>
        <i></i>
      </div>

      <div class="container cooming-soon">
        <div class="row mb-50">
          <div class="col-md-6 left">
            <div class="clock-box">
              <div>
                <div class="mb-4">
                  <h2>We Are Launching Soon</h2>
                  <img
                    src="../assets/images/title-line.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <div id="clockdiv">
                  <div class="mr-2">
                    <span class="days">{{ days }}</span>
                    <div class="smalltext">Days</div>
                  </div>
                  <div class="mr-2">
                    <span class="hours">{{ hours }}</span>
                    <div class="smalltext">Hours</div>
                  </div>
                  <div class="mr-2">
                    <span class="minutes">{{ minutes }}</span>
                    <div class="smalltext">Minutes</div>
                  </div>
                  <div class="mr-2">
                    <span class="seconds">{{ seconds }}</span>
                    <div class="smalltext">Seconds</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="home-right">
              <div class="animation-circle-inverse">
                <i></i>
                <i></i>
                <i></i>
              </div>
              <div class="mobile-slid">
                <img
                  src="../assets/images/top-mobile.png"
                  alt="top1"
                  class="img-fluid"
                />
              </div>
              <div class="profile-msg">
                <img
                  src="../assets/images/top2.png"
                  alt="top2"
                  class="img-fluid"
                />
              </div>
              <div class="awesome">
                <img
                  src="../assets/images/top3.png"
                  alt="top3"
                  class="img-fluid"
                />
              </div>
              <div class="profile-1">
                <img
                  src="../assets/images/top4.png"
                  alt="top4"
                  class="img-fluid"
                />
              </div>
              <div class="emoji">
                <img
                  src="../assets/images/top5.png"
                  alt="top5"
                  class="img-fluid"
                />
              </div>
              <div class="profile-2">
                <img
                  src="../assets/images/top1.png"
                  alt="top1"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="subscribe-bg">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-lg-4">
            <div class="subscribe">
              <h3>Subscribe to Newsletter</h3>
            </div>
          </div>
          <div class="col-sm-12 col-lg-8">
            <div class="email-box">
              <form>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  placeholder="Enter your email"
                />
                <button type="submit" class="btn btn-email">Subscribe</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Page Ends-->
    <Copyright />
  </div>
</template>
<script>
export default {
  data() {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  },
  mounted() {
    document.body.classList.remove("inner-page");
    var second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;
    var countDown = new Date("Aug 21, 2023 00:00:00").getTime();
    setInterval(() => {
      var now = new Date().getTime();
      this.days = Math.floor((countDown - now) / day);
      this.hours = Math.floor(((countDown - now) % day) / hour);
      this.minutes = Math.floor(((countDown - now) % hour) / minute);
      this.seconds = Math.floor(((countDown - now) % minute) / second);
    }, second);
  },
};
</script>
